export default __webpack_public_path__ + "static/Zhanna Manukian-634c750af678489378df3be3ec29e371.png";